import { Card, ListLayout } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { useTranslation } from '~src/i18n/use-translation';
import { formatAddonTitle } from '~src/pages/shipment/create/carrier-product-addons';

import { ShipmentTemplateDetails } from '../types';

interface Props {
  template: ShipmentTemplateDetails;
}

export function CarrierProduct({ template }: Props) {
  const { t } = useTranslation();

  if (!template.shipping_method?.id) {
    return null;
  }

  return (
    <Card.List>
      <Card.Wrapper>
        <Card.Header>{t('common.carrierProduct')}</Card.Header>
        <Card.Content>
          <ListLayout.Column>
            <ListLayout.Row>
              <ShippingLogo method={template.shipping_method.id} width="40" />
              <ListLayout.Stack>
                <ListLayout.PrimaryText>{template.shipping_method?.carrier}</ListLayout.PrimaryText>
                <ListLayout.SecondaryText>{template.shipping_method?.name}</ListLayout.SecondaryText>
              </ListLayout.Stack>
            </ListLayout.Row>
          </ListLayout.Column>
        </Card.Content>
        {template.addons && template.addons.length > 0 && (
          <Card.Content>
            <ListLayout.Stack>
              <ListLayout.PrimaryText>{t('common.addons')}</ListLayout.PrimaryText>
              <ListLayout.SubRow gap="lg">
                {template.addons.map(addon => (
                  <ListLayout.SecondaryText key={addon.code}>{formatAddonTitle(addon)}</ListLayout.SecondaryText>
                ))}
              </ListLayout.SubRow>
            </ListLayout.Stack>
          </Card.Content>
        )}
      </Card.Wrapper>
    </Card.List>
  );
}
